import { render, staticRenderFns } from "./StandardLights.vue?vue&type=template&id=c525c46c&"
import script from "./StandardLights.vue?vue&type=script&lang=js&"
export * from "./StandardLights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports